import { REACT_APP_API_ABM_FW } from '../../config'
import axios from 'axios'

export const updateUnreadPushNotifications = async (userId, clearUnread = false, unreadQuantity = null) => {
    try {
        await axios.put(`${REACT_APP_API_ABM_FW}/users/updateUnreadPushNotifications/${userId}`, { clearUnread, unreadQuantity })
    } catch (error) {
        throw new Error(error)
    }
}
